const FR_MONTHS: Record<string, number> = {
  janvier: 0, février: 1, mars: 2, avril: 3, mai: 4, juin: 5,
  juillet: 6, août: 7, septembre: 8, octobre: 9, novembre: 10, décembre: 11,
};

/** Parses "~22 juillet 2026" / "22 juillet 2026" into an ISO date ("2026-07-22"), or null if unparseable. */
export function parseApproxFrenchDate(str: string): string | null {
  // \p{L}+ (not \w+) — \w is ASCII-only and silently fails to match accented
  // month names like "août" or "février", which \d+\s+\w+ would otherwise
  // truncate mid-word and reject.
  const match = str.match(/~?(\d+)\s+(\p{L}+)\s+(\d{4})/u);
  if (!match) return null;
  const month = FR_MONTHS[match[2].toLowerCase()];
  if (month === undefined) return null;
  const day = match[1].padStart(2, "0");
  return `${match[3]}-${String(month + 1).padStart(2, "0")}-${day}`;
}

export function daysUntil(isoDate: string): number {
  const diff = new Date(`${isoDate}T23:59:00`).getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / 86400000));
}

/** Convenience for the "~22 juillet 2026" display-string dates already used in prepQuestions.ts. */
export function daysUntilFrenchDate(str: string): number {
  const iso = parseApproxFrenchDate(str);
  return iso ? daysUntil(iso) : 0;
}
